import ContenedorPrincipal from './componentes/contenedorPrincipal';

export default ContenedorPrincipal;
